import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class LoaderService {
    public loaderCounter= new BehaviorSubject<boolean>(false);
    isLoadable = false;
    constructor() {
    }
    isLoaded(): Observable<any> {
        return this.loaderCounter.asObservable();
    }
    load(value: boolean) {
        this.loaderCounter.next(value);
    }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/_services/loader.service.ts